<template>
    <div class="chart-page">
        <v-row>
            <v-col cols="2" sm="2" class="paddintp0"></v-col>
            <v-col cols="8" sm="8" class="paddintp0">
                <div class="switch-group">
                    <div
                        class="switch-cust"
                        v-for="subject in Object.keys(subjects)"
                        :key="subject"
                    >
                        <v-switch v-model="subjects[subject].value" inset :label="subject"></v-switch>
                    </div>
                </div>
                <div class="switch-group group-2">
                    <div class="check-cust correct-check">
                        <v-checkbox
                            v-model="questionStatus.correct"
                            label="Correct"
                            dense
                            hide-details
                        ></v-checkbox>
                    </div>
                    <div class="check-cust incorrect-check">
                        <v-checkbox
                            v-model="questionStatus.incorrect"
                            label="Incorrect"
                            dense
                            hide-details
                        ></v-checkbox>
                    </div>
                    <div class="check-cust unanswered-check">
                        <v-checkbox
                            v-model="questionStatus.unAnswered"
                            label="Unanswered"
                            dense
                            hide-details
                        ></v-checkbox>
                    </div>
                    <div class="check-cust partiallycorrect-check">
                        <v-checkbox
                            v-model="questionStatus.partiallyCorrect"
                            label="Partially Correct"
                            dense
                            hide-details
                        ></v-checkbox>
                    </div>
                </div>
            </v-col>
            <!-- <v-col cols="2" sm="2" class="paddintp0">
                <div class="chart-top-btn-how">
                    <v-btn @click="howItWorks" class="how-sub-btn" outlined>How This Works</v-btn>
                </div>
            </v-col> -->
        </v-row>
        <v-row>
            <v-col cols="12" sm="12" class="relativeblock">
                <div class="time_machin">
                    <div v-for="(list, listIndex) in timeMachineList" :key="listIndex">
                        <div class="time_left">
                            <div v-if="list.showLeft" class="half-circle">
                                <img src="../../assets/arrow-right.png" class="arrow-direction" />
                            </div>
                            <span
                                v-if="list.leftSideTimeInfo"
                                class="min_I"
                            >{{list.leftSideTimeInfo}}</span>
                        </div>

                        <div class="time_center">
                            <div class="Q_row flex_row">
                                <div
                                    v-for="(question, questionIndex) in list.questions"
                                    :key="questionIndex"
                                    :style="question.style"
                                    class="timemachine-col"
                                >
                                    <v-tooltip top content-class="time-machine-tooltip">
                                        <template v-slot:activator="{ on }">
                                            <div
                                                v-show="questionStatus[question.status] && subjects[question.subjectName] && subjects[question.subjectName].value"
                                                v-on="on"
                                                class="questionData"
                                                :class="question.class"
                                            >
                                                <div class="normal-text-bold">{{"Q." + question.questionNo}}</div>
                                            </div>
                                        </template>
                                        <div>
                                            <div class="normal-text-data">Q no. <span class="normal-text-bold">{{question.questionNo}}</span></div>
                                            <div class="normal-text-data">Total Time Spent: <span class="normal-text-bold">{{question.timeSpent}} sec.</span></div>
                                            <div class="normal-text-data">Chapter Name: <span class="normal-text-bold">{{question.chapterName}}</span></div>
                                        </div>
                                    </v-tooltip>
                                </div>
                            </div>
                        </div>
                        <div class="time_right">
                            <div v-if="list.showRight" class="half-circle">
                                <img src="../../assets/arrow-left.png" class="arrow-direction" />
                            </div>
                            <span
                                v-if="list.rightSideTimeInfo"
                                class="min_I"
                            >{{list.rightSideTimeInfo}}</span>
                        </div>
                    </div>
                </div>
                <div class="chart-indicate-block">
                    <div class="chart-indicator indicator-time">
                        <div class="indicator-block">
                            <div class="indicator-color correct"></div>
                            <div class="indicator-text">Correct</div>
                        </div>
                        <div class="indicator-block">
                            <div class="indicator-color incorrect"></div>
                            <div class="indicator-text">Incorrect</div>
                        </div>
                        <div class="indicator-block">
                            <div class="indicator-color unanswered"></div>
                            <div class="indicator-text">Unanswered</div>
                        </div>
                        <div class="indicator-block">
                            <div class="indicator-color partiallycorrect"></div>
                            <div class="indicator-text">Partially Correct</div>
                        </div>
                    </div>
                </div>
            </v-col>
        </v-row>
        <!-- <v-row>
            <v-col cols="12" sm="12" class="paddintp0-1">
                <div class="chart-indicator indicator-time">
                    <div class="indicator-block">
                        <div class="indicator-color correct"></div>
                        <div class="indicator-text">Correct</div>
                    </div>
                    <div class="indicator-block">
                        <div class="indicator-color incorrect"></div>
                        <div class="indicator-text">Incorrect</div>
                    </div>
                    <div class="indicator-block">
                        <div class="indicator-color unanswered"></div>
                        <div class="indicator-text">Unanswered</div>
                    </div>
                    <div class="indicator-block">
                        <div class="indicator-color partiallycorrect"></div>
                        <div class="indicator-text">Partially Correct</div>
                    </div>
                </div>
            </v-col>
        </v-row> -->
        <AlertBox
            :width="modalwidth"
            :onClose="onClose"
            :component="cComponent"
            :status="status"
            :data="alertBoxData"
        />
    </div>
</template>
<script>
import { mapActions, mapState } from "vuex";

export default {
    name: "TimeMachine",
    mounted() {
        this.getSubjects();
        this.getTimeMachineData();
    },
    props: ["studentId", "studentTestId"],
    data() {
        return {
            cComponent: "components/coordinator/AddBatch",
            alertBoxData: {},
            status: false,
            modalwidth: "70%",
            subjects: {},
            selectedSubject: [],
            timeMachineList: [],
            questionStatus: {
                correct: true,
                incorrect: true,
                unAnswered: true,
                partiallyCorrect: true
            }
        };
    },
    computed: {
        ...mapState("userStore", ["user"])
    },
    methods: {
        ...mapActions({
            getTimeMachineList: "resultStore/getTimeMachineList",
            getTestSubjects: "resultStore/getTestSubjects"
        }),
        howItWorks() {
            this.cComponent = "components/student/HowItWorks";
            this.alertBoxData = {
                image: this.TESTWISEANALYSIS_TEST_TYPES.TIMEMACHINE
            };
            this.modalwidth = "70%";
            this.status = true;
            this.$forceUpdate();
        },
        onClose(data) {
            this.status = data.status;
        },
        getSubjects() {
            let test_id = this.$route.params.test_id;
            let reqData = { test_id, student_id: this.studentId };
            this.$root.showLoader = true;
            this.getTestSubjects(reqData)
                .then(response => {
                    response.forEach(subject => {
                        this.$set(this.subjects, subject.title, {
                            value: true,
                            id: subject.id
                        });
                    });
                    this.$forceUpdate();
                })
                .catch(err => {
                    this.$root.showLoader = false;
                });
        },
        getTimeMachineData() {
            let testInstituteId = this.$route.params.test_institute_id;
            let reqData = {
                test_institute_id: testInstituteId,
                student_id: this.studentId,
                student_test_id: this.studentTestId
            };
            this.$root.showLoader = true;
            this.getTimeMachineList(reqData)
                .then(response => {
                    this.processTimeMachineData(response);
                })
                .catch(err => {
                    this.$root.showLoader = false;
                });
        },
        getWidth(timeSpent) {
            let width = 0;
            width = (timeSpent * 100) / 1800;
            return width.toFixed(2);
        },
        getClass(ans) {
            let status = "";
            let className = "";
            switch (ans) {
                case "PC":
                    status = "partiallyCorrect";
                    className = "partiallycorrect";
                    break;
                case "C":
                    status = "correct";
                    className = "correct";
                    break;
                case "IC":
                    status = "incorrect";
                    className = "incorrect";
                    break;
                case "NA":
                    status = "unAnswered";
                    className = "unanswered";
                    break;
            }
            return { status, className };
        },
        processTimeMachineData(response) {            
            let timeMachineList = [];
            let currentIndex = 0;
            let totalSecondsPerHalfHr = 0;
            let totalSecondsSpentInTest = 0;
            let rightPercentage = 0.0;
            let direction = "left";
            let ttime = 0;
            response.activities.forEach((queData, idx) => {
                ttime+=queData.spent_time_in_sec;
            })
            response.activities.forEach((queData, idx) => {
                let timeSpent = queData.spent_time_in_sec;
                totalSecondsPerHalfHr += timeSpent;
                totalSecondsSpentInTest += timeSpent;
                if (totalSecondsPerHalfHr > 1800) {
                    let remainingTime = totalSecondsPerHalfHr - timeSpent;
                    timeSpent = 1800 - remainingTime;
                }
                let questionObj = {};
                let width = this.getWidth(timeSpent);
                questionObj.style = { width: width + "%" };
                questionObj.style[direction] = rightPercentage + "%";
                rightPercentage += parseFloat(width);

                questionObj.id = queData.question_id;
                questionObj.questionNo = queData.index;
                questionObj.timeSpent = timeSpent;
                questionObj.chapterName = queData.chapter_name;
                questionObj.subjectName = queData.subject_name;
                questionObj.subjectId = queData.subject_id;
                let status = this.getClass(queData.your_attempt);
                questionObj.status = status.status;
                questionObj.class = status.className;
                if (!timeMachineList[currentIndex]) {
                    timeMachineList[currentIndex] = { questions: [] };
                }
                timeMachineList[currentIndex].questions.push(questionObj);

                if (totalSecondsPerHalfHr > 1800) {
                    let extraTime = totalSecondsPerHalfHr - 1800;

                    while (extraTime > 1800) {
                        let halfHrTime = 1800;
                        let timeMachineData = this.updateTimeMachineObj(
                            timeMachineList,
                            direction,
                            questionObj,
                            halfHrTime,
                            currentIndex
                        );
                        currentIndex = timeMachineData.currentIndex;
                        direction = timeMachineData.direction;
                        timeMachineList = timeMachineData.timeMachineList;
                        extraTime -= halfHrTime;
                    }
                    if (extraTime > 0) {
                        let timeMachineData = this.updateTimeMachineObj(
                            timeMachineList,
                            direction,
                            questionObj,
                            extraTime,
                            currentIndex
                        );
                        currentIndex = timeMachineData.currentIndex;
                        direction = timeMachineData.direction;
                        timeMachineList = timeMachineData.timeMachineList;
                        totalSecondsPerHalfHr = extraTime;
                        rightPercentage = parseFloat(timeMachineData.width);
                    }
                }
            });
            let duration = parseInt(response.testDetails.duration);
            timeMachineList = this.checkAndUpdateUnusedTime(
                timeMachineList,
                duration
            );
            let timeMachineLength = duration / 30;
            let remainingLength = 0;

            timeMachineLength =
                timeMachineLength > parseInt(timeMachineLength)
                    ? parseInt(timeMachineLength + 1)
                    : timeMachineLength;
                    timeMachineList.length = timeMachineLength;
            timeMachineList = this.getArrowDetails(timeMachineList, duration);
            this.timeMachineList = timeMachineList.reverse();
            this.$root.showLoader = false;
        },
        updateTimeMachineObj(
            timeMachineList,
            direction,
            questionObj,
            timeSpent,
            currentIndex
        ) {
            let rightPercentage = 0.0;
            direction = direction == "left" ? "right" : "left";
            let clonedQuestionObj = _.cloneDeep(questionObj);
            let width = this.getWidth(timeSpent);
            clonedQuestionObj.timeSpent = timeSpent;
            clonedQuestionObj.style = { width: width + "%" };
            clonedQuestionObj.style[direction] = rightPercentage + "%";
            currentIndex++;
            if (!timeMachineList[currentIndex]) {
                timeMachineList[currentIndex] = {
                    questions: []
                };
            }
            timeMachineList[currentIndex].questions.push(clonedQuestionObj);
            return { timeMachineList, direction, currentIndex, width };
        },
        checkAndUpdateUnusedTime(timeMachineList, duration) {
            let currentTimeMachineListLength = timeMachineList.length;
            let timeMachineLength = duration / 30;
            let remainingLength = 0;

            timeMachineLength =
                timeMachineLength > parseInt(timeMachineLength)
                    ? parseInt(timeMachineLength + 1)
                    : timeMachineLength;
            remainingLength = timeMachineLength - currentTimeMachineListLength;
            if (remainingLength == 0) return timeMachineList;
            for (let i = 0; i < remainingLength; i++) {
                let timeMachineObj = {
                    questions: []
                };
                timeMachineList.push(timeMachineObj);
            }

            return timeMachineList;
        },
        getArrowDetails(timeMachineList, duration) {
            let from = 0;
            let to = 30;

            timeMachineList = timeMachineList.map((tml, idx) => {
                tml.showLeft = false;
                tml.showRight = false;
                if (timeMachineList.length == 1) {
                    tml.leftSideTimeInfo = from + " - " + to + " Min";
                    return tml;
                }
                if (idx == 0 || idx % 2 == 0) {
                    tml.leftSideTimeInfo = from + " - " + to + " Min";
                    if (timeMachineList.length - 1 != idx) tml.showRight = true;
                } else if (idx % 2 == 1) {
                    tml.rightSideTimeInfo = from + " - " + to + " Min";
                    if (timeMachineList.length - 1 != idx) tml.showLeft = true;
                }
                from = to;
                to = duration - to > 30 ? to + 30 : duration;

                return tml;
            });
            return timeMachineList;
        }
    }
};
</script>